import React, { Component } from 'react';
import { connect } from "react-redux";
import { Card, CardBody, CardHeader, Row, Col, Button, Label, UncontrolledCollapse } from 'reactstrap';
import { AvForm, AvGroup, AvField, AvInput } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../i18next';

import { getCurrencySymbol, localizeCountryNames, isUserAllowedToAddBrands } from '../../../../utils/CommonUtils';
import { dispatchErrorMessage } from '../../../../actions/index';
import Map from './Map';
import DeliveryZoneConfirmationScreen from './DeliveryZoneConfirmationScreen';
import DeliveryProviderByZoneScreen from './DeliveryProviderByZoneScreen';

let currentGeometryLocation = null;
let currentGeometryBounds = null;
let mapInstance = null;

class DeliveryZoneItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            deliveryZone: null,
            inactiveDeliveryZones: null,
            drawingManager: null,
            completedPolygon: null,
            zoneType: null,
            areaColor: '',
            collapsibleContainerOpened: false,
            scrollToElement: null,
            mapDrawed: null,
            map: null,
            zoneConfirmationScreenOpened: false,
            stateAlreadyCopiedFromProps: false,
            zoneMap: null,
            currentPolygonPreview: null,
            isUpdateZone: false
        };

        this.handleInvalidSubmit = this.handleInvalidSubmit.bind(this);
        this.removeAreaFromMap = this.removeAreaFromMap.bind(this);
    }

    copyStateFromProps() {

        if (this.props !== undefined && this.props !== null &&
            (!this.state.stateAlreadyCopiedFromProps && this.state.zoneType !== this.props.zoneType)) {

            let mapDrawed = null;
            if (this.props.deliveryZone.verticesCoordinates !== undefined && this.props.deliveryZone.verticesCoordinates !== null
                && this.props.deliveryZone.verticesCoordinates.length) {
                mapDrawed = true;
            } else {
                mapDrawed = false;
            }

            this.setState({
                deliveryZone: this.props.deliveryZone,
                inactiveDeliveryZones: this.props.inactiveDeliveryZones,
                drawingManager: null,
                completedPolygon: null,
                zoneType: this.props.zoneType,
                areaColor: this.props.deliveryZone.color,
                collapsibleContainerOpened: false,
                scrollToElement: null,
                mapDrawed: mapDrawed,
                stateAlreadyCopiedFromProps: true
            });
        }
    }

    componentWillUnmount() {
        let INITIAL_STATE = {
            deliveryZone: null,
            inactiveDeliveryZones: null,
            drawingManager: null,
            completedPolygon: null,
            zoneType: null,
            areaColor: '',
            collapsibleContainerOpened: false,
            scrollToElement: null,
            mapDrawed: null,
            map: null,
            stateAlreadyCopiedFromProps: false
        };

        this.state = INITIAL_STATE;
    }

    componentDidMount() {
        // Listen for full screen enter/exit mode on map and reset the zoom to fit the bounds of the delivery zones
        document.addEventListener("fullscreenchange", () => {
            if (mapInstance && currentGeometryBounds) mapInstance.fitBounds(currentGeometryBounds);
        });

        this.copyStateFromProps();
    }

    componentDidUpdate(prevProps) {
        // Scroll the element into view
        if (this.state.scrollToElement) {
            this.state.scrollToElement.scrollIntoView({ behavior: "smooth" })
        }
    }

    renderCardHeader() {
        const { cursorPointer, alignRight, expandMoreIcon, collapseZindex, expandLessIcon } = this.props.styles;
        const { id } = this.props.deliveryZone;

        return (
            <CardHeader id={`toggler${id}`} style={cursorPointer} >
                <Row>
                    <Col>{this.props.deliveryZone.name}</Col>
                    <Col style={alignRight}>
                        <span style={expandMoreIcon}><MaterialIcon icon='expand_more' color="#000" size={18} /></span>
                        <UncontrolledCollapse style={collapseZindex} toggler={`#toggler${id}`}>
                            <span style={expandLessIcon}><MaterialIcon icon='expand_less' color="#000" size={18} /></span>
                        </UncontrolledCollapse>
                    </Col>
                </Row>
            </CardHeader>
        );
    }

    renderCardBodyLeftColumn() {
        const { cardBodyLeftCol, secondLabels, checkboxInput, currencyTypeStyle, deliveryChargeLabel,
            zeroPadding, zeroPaddingRight, avFormGroup, avField } = this.props.styles;

        const { id, name, deliveryTime, deliveryCharge, minimumOrderAmount, maximumOrderAmount,
            deliveryChargeInPercentage } = this.props.deliveryZone;

        const { changeDeliveryZoneState } = this.props;

        const currencyTypeSign = this.props.currency;
        const currencyOrPercentage = (deliveryChargeInPercentage === true || deliveryChargeInPercentage === 'true') ? '%' : currencyTypeSign;

        return (
            <Col sm={5} style={cardBodyLeftCol}>
                <AvGroup row>
                    <Label sm={4} style={zeroPaddingRight}>{i18n.t('common:form.name')}</Label>
                    <Col sm={8} style={zeroPadding} >
                        <AvField
                            id={id + ''} type="text" name="name" required
                            value={name} onChange={changeDeliveryZoneState} errorMessage={i18n.t('common:validations.errorMsg')} />
                    </Col>
                </AvGroup>
                <AvGroup row style={avFormGroup}>
                    <Label sm={7} style={zeroPaddingRight}>{i18n.t('screens:deliveryZoneItem.deliveryTime')}</Label>
                    <AvField
                        id={id + ''} type="number" name="deliveryTime" style={avField}
                        value={deliveryTime} onChange={changeDeliveryZoneState}
                        min={1} required errorMessage={i18n.t('common:validations.errorMsg')} onKeyPress={(e) => this.negativeIntegersValidation(e)}
                    />
                    <Label style={secondLabels}>{i18n.t('screens:preparationTimes.min')}</Label>
                </AvGroup>
                <AvGroup row style={avFormGroup}>
                    <Label sm={7} style={zeroPaddingRight}>{i18n.t('screens:deliveryZoneItem.deliveryCharge')}</Label>
                    <AvField
                        id={id + ''} style={avField} type="number" name="deliveryCharge"
                        //The field's value is stringified because maybe AvField has problems with falsey values and does not want to display zeros
                        value={deliveryCharge} onChange={changeDeliveryZoneState}
                        min={0} onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                    />
                    <Label style={secondLabels}>{currencyOrPercentage}</Label>
                </AvGroup>
                <AvGroup row>
                    <Label sm={7} style={deliveryChargeLabel}>{i18n.t('screens:deliveryZoneItem.chargeInPercentage')}</Label>
                    <AvInput
                        id={id + ''} style={checkboxInput} type="checkbox" name="deliveryChargeInPercentage"
                        value={!!deliveryChargeInPercentage} onChange={changeDeliveryZoneState}
                    />
                </AvGroup>
                <AvGroup row style={avFormGroup}>
                    <Label sm={7} style={zeroPaddingRight}>{i18n.t('common:deliveryCollectionDineInCurbside.minOrderAmount')}</Label>
                    <AvField
                        id={id + ''} type="number" name="minimumOrderAmount" style={avField}
                        value={minimumOrderAmount} onChange={changeDeliveryZoneState}
                        min={1} required errorMessage={i18n.t('common:validations.errorMsg')} onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                    />
                    <Label sm={1} style={currencyTypeStyle}>{currencyTypeSign}</Label>
                </AvGroup>
                <AvGroup row style={avFormGroup}>
                    <Label sm={7} style={zeroPaddingRight}>{i18n.t('common:deliveryCollectionDineInCurbside.maxOrderAmount')}</Label>
                    <AvInput
                        id={id + ''} type="number" name="maximumOrderAmount" style={avField}
                        value={maximumOrderAmount === null ? '' : maximumOrderAmount} onChange={changeDeliveryZoneState}
                        onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                    />
                    <Label sm={1} style={currencyTypeStyle}>{currencyTypeSign}</Label>
                </AvGroup>
            </Col>
        );
    }

    renderCircleTypeButtons() {
        const { zeroPaddingRight, avFormGroup, avField } = this.props.styles;

        const { id } = this.props.deliveryZone;

        const { changeDeliveryZoneState } = this.props;

        let measureUnit = null;
        let startRange = null;
        let endRange = null;

        if (this.props.deliveryZone.deliveryZoneCircleRange) {
            measureUnit = this.props.deliveryZone.deliveryZoneCircleRange.measureUnit;
            startRange = this.props.deliveryZone.deliveryZoneCircleRange.startRange;
            endRange = this.props.deliveryZone.deliveryZoneCircleRange.endRange;
        }

        return (
            <div style={{ display: 'flex', marginBottom: 10, justifyContent: 'flex-start'}}>
                <AvGroup row style={{...avFormGroup, marginLeft: 0, marginRight: '20px', marginBottom: '0'}}>
                    <Label style={{...zeroPaddingRight, marginRight: '15px', marginTop: '10px'}}>{i18n.t('common:deliveryCollectionDineInCurbside.unit')}</Label>
                    <AvField
                        id={id + ''} type="select" name="measureUnit" style={avField}
                        value={measureUnit} onChange={changeDeliveryZoneState}
                        errorMessage={i18n.t('common:validations.errorMsg')}
                        required
                    >
                        <option></option>
                        <option>{i18n.t('screens:deliveryZoneItem.km')}</option>
                        <option>{i18n.t('screens:deliveryZoneItem.mi')}</option>
                    </AvField>
                </AvGroup>
                <AvGroup row style={{...avFormGroup, marginRight: '20px', marginBottom: '0'}}>
                    <Label style={{...zeroPaddingRight, marginRight: '15px', marginTop: '10px'}}>{i18n.t('common:deliveryCollectionDineInCurbside.from')}</Label>
                    <AvField
                        id={id + ''} type="number" name="startRange" style={avField}
                        value={`${startRange}`} onChange={changeDeliveryZoneState}
                        min={0} required errorMessage={i18n.t('common:validations.errorMsg')} onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                    />
                </AvGroup>
                <AvGroup row style={{...avFormGroup, marginRight: '20px', marginBottom: '0'}}>
                    <Label style={{...zeroPaddingRight, marginRight: '15px', marginTop: '10px'}}>{i18n.t('common:deliveryCollectionDineInCurbside.to')}</Label>
                    <AvField
                        id={id + ''} type="number" name="endRange" style={avField}
                        value={`${endRange}`} onChange={changeDeliveryZoneState}
                        min={0} required errorMessage={i18n.t('common:validations.errorMsg')} onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                    />
                </AvGroup>
                <AvGroup>
                    <Button color="primary" style={{ zIndex: 2 }} onClick={() => this.onClickPreview()}>
                        <MaterialIcon icon="visibility" color="#fff" size={18} /><span style={this.props.styles.spaceBetween}>{i18n.t('common:buttons.preview')}</span>
                    </Button>
                </AvGroup>
            </div>
        )
    }

    onClickPreview() {
        if (this.state.isUpdateZone) {
            this.renderCircleZone(null);
            this.renderCircleZone(this.state.zoneMap)
        } else {
            this.previewCircleZone(null);
            this.previewCircleZone(this.state.zoneMap);
        }
    }

    negativeIntegersValidation(e) {

        var inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode === 45 || inputKeyCode === 46 || inputKeyCode === 43
                || inputKeyCode === 69 || inputKeyCode === 101) {
                e.preventDefault();
            }
        }
    }

    negativeDecimalsValidation(e) {
        var inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    renderColorOptions() {
        const colours = ["RED", "GREEN", "BLUE", "YELLOW", "ORANGE", "GRAY"];

        return colours.map((colorCapital, i) => {
            let color = colorCapital.toLowerCase();

            return (
                <option key={i} value={colorCapital}>{i18n.t(`screens:deliveryZoneItem.${color}`)}</option>
            );
        });
    }

    renderZipCodes() {
        const { zipCodesLabel, textArea } = this.props.styles;
        const { changeDeliveryZoneState } = this.props;
        const { id, zipCodes } = this.props.deliveryZone;

        return (
            <AvGroup>
                <Label style={zipCodesLabel}>{i18n.t(`screens:deliveryZoneItem.zipCodes`)}</Label>
                <AvField
                    id={id + ''} type="textarea" name="zipCodes" style={textArea}
                    value={zipCodes} required onChange={changeDeliveryZoneState} />
            </AvGroup>
        );
    }

    renderSaveButton() {
        const { spaceBetween } = this.props.styles;

        return (
            <Button color="primary">
                <MaterialIcon icon="save" color="#fff" size={18} /><span style={spaceBetween}>{i18n.t('common:buttons.save')}</span>
            </Button>
        );
    }

    renderDeleteButton(id) {
        const { spaceBetween, spaceBetweenBtns } = this.props.styles;

        return (
            <Button onClick={(id) => {
                this.setState({ ...this.state, zoneConfirmationScreenOpened: true });
            }}
                id="deleteDeliveryZoneItem"
                color="primary"
                outline
                style={spaceBetweenBtns}>
                <MaterialIcon icon="delete" color="#0288D1" size={18} />
                <span style={spaceBetween}>{i18n.t('common:buttons.delete')}</span>
            </Button>
        );
    }

    removeAreaFromMap() {
        // Remove the polygon from the map
        let polygon = this.state.completedPolygon;

        polygon.setMap(null);

        let updatedDeliveryZone = { ...this.state.deliveryZone };
        updatedDeliveryZone.verticesCoordinates = null;

        this.state.deliveryZone = updatedDeliveryZone;
        this.state.completedPolygon = null;
        this.state.mapDrawed = false;

        this.initDrawingMode(this.state.map);
    }

    centerMapOnRestaurantCity(map) {

        let country = localizeCountryNames(this.props.restaurant.address.country);
        let city = this.props.restaurant.address.city;
        let restaurantAddress = String(city) + ' , ' + String(country);
        const { inactiveDeliveryZones } = this.props;

        // Listen for full screen enter/exit mode on map
        document.addEventListener("fullscreenchange", () => {
            map.setCenter(currentGeometryLocation);
            map.fitBounds(currentGeometryBounds);
        });

        let geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ 'address': restaurantAddress }, (results, status) => {
            if (status === window.google.maps.GeocoderStatus.OK) {

                map.setCenter(results[0].geometry.location);
                let bounds = new window.google.maps.LatLngBounds();

                // If there are delivery zones for the restaurant zoom map bounds to the zones not to the restaurantAddress
                if (inactiveDeliveryZones) {

                    inactiveDeliveryZones.map((zone) => {
                        zone.verticesCoordinates.map((cord) => {
                            bounds.extend(new window.google.maps.LatLng(cord.latitude, cord.longitude));
                        })
                    });

                    // If there are no inactive delivery zones
                    if (inactiveDeliveryZones.length === 0) {
                        map.fitBounds(results[0].geometry.bounds);
                        bounds = results[0].geometry.bounds;
                    }
                }

                map.fitBounds(bounds);

                // Save the located address cords and bounds to use them when we have no delivery zones and enter full screen on the map
                currentGeometryLocation = results[0].geometry.location;
                currentGeometryBounds = bounds;

                // Set map to drawing mode
                // this.renderShowMap(map);
                this.initDrawingMode(map);
                this.addInactiveDeliveryZonesToMap(map);
                this.state.map = map;
            } else {
                // TODO if no data for the full adress try again with only the city

                geocoder.geocode({ 'address': city }, (results, status) => {
                    map.setCenter(results[0].geometry.location);
                    map.fitBounds(results[0].geometry.bounds);

                    // Save the located address cords and bounds to use them when we have no delivery zones and enter full screen on the map
                    currentGeometryLocation = results[0].geometry.location;
                    currentGeometryBounds = results[0].geometry.bounds;

                    // Set map to drawing mode
                    // this.renderShowMap(map);
                    this.initDrawingMode(map);
                    this.addInactiveDeliveryZonesToMap(map);
                    this.state.map = map;
                });
            }
        });

    }

    renderDeleteAreaButton() {
        const { deleteDrawingIcon } = this.props.styles;

        return (
            <span style={deleteDrawingIcon} onClick={this.removeAreaFromMap}>
                <MaterialIcon icon="delete" color="#f98484" size={25} />
            </span>
        );
    }

    renderShowMap(map) {
        let bounds = new window.google.maps.LatLngBounds();

        if (this.state.inactiveDeliveryZones) {
            this.addInactiveDeliveryZonesToMap(map);
        }

        mapInstance = map;

        let formattedCords = [];

        if (this.state.deliveryZone.verticesCoordinates.length) {

            this.state.deliveryZone.verticesCoordinates.map((cord) => {
                let formattedCord = { lat: cord.latitude, lng: cord.longitude };
                formattedCords.push(formattedCord);
            });

            let currentZone = new window.google.maps.Polygon({
                paths: formattedCords,
                strokeColor: this.state.deliveryZone.color,
                strokeOpacity: 0.6,
                strokeWeight: 3,
                fillColor: this.state.deliveryZone.color,
                fillOpacity: 0.35
            });

            this.setState({ ...this.state, map: map, completedPolygon: currentZone }, () => {

                // Make polygon editable On click
                window.google.maps.event.addListener(this.state.completedPolygon, 'click', (index) => {
                    const { completedPolygon } = this.state;

                    let drawingManager = new window.google.maps.drawing.DrawingManager({
                        drawingMode: window.google.maps.drawing.OverlayType.POLYGON,
                        drawingControl: true,
                        drawingControlOptions: {
                            position: window.google.maps.ControlPosition.TOP_CENTER,
                            drawingModes: ['polygon']
                        },
                        polygonOptions: {
                            fillColor: this.state.areaColor ? this.state.areaColor : 'GRAY',
                            fillOpacity: 0.6,
                            strokeColor: this.state.areaColor ? this.state.areaColor : 'GRAY',
                            strokeWeight: 3,
                            strokeOpacity: 0.35,
                            clickable: true,
                            editable: true,
                            zIndex: 1
                        }
                    });

                    // Get delivery zone info on click
                    let updatedDeliveryZone = this.udpatePolygonCoordinates(completedPolygon, drawingManager);

                    this.setState({ ...this.state, deliveryZone: updatedDeliveryZone, completedPolygon: completedPolygon }, () => {

                        completedPolygon.setEditable(true);
                        completedPolygon.getPaths().forEach((path, index) => this.handlePolygonUpdate(path, completedPolygon, drawingManager));

                    });

                });

            });

            currentZone.setMap(map);

            // Add current Zone cords to map bounds so the map zoom to bounds
            for (let i = 0, l = formattedCords.length; i < l; i++) {
                bounds.extend(formattedCords[i]);
            }

        } else {
            this.initDrawingMode(map)
        }
        if (this.state.deliveryZone.verticesCoordinates.length) {
            map.fitBounds(bounds);
        }
        currentGeometryBounds = bounds;

        // Control the zoom of the map
        let listener = window.google.maps.event.addListener(map, "idle", function () {
            if (map.getZoom() > 16) map.setZoom(14);
            if (map.getZoom() <= 7) map.setZoom(15);
            window.google.maps.event.removeListener(listener);
        });
    }

    addInactiveDeliveryZonesToMap(map) {

        if (this.state.inactiveDeliveryZones) {
            // Render the other zones
            this.state.inactiveDeliveryZones.map((zone) => {
                // Format the coordinates in the correct format for the google maps api
                let formattedCords = [];

                if (zone.verticesCoordinates) {
                    zone.verticesCoordinates.map((cord) => {
                        let formattedCord = { lat: cord.latitude, lng: cord.longitude };
                        formattedCords.push(formattedCord);
                    });

                    let currentZone = new window.google.maps.Polygon({
                        paths: formattedCords,
                        strokeColor: zone.color,
                        strokeOpacity: 0.6,
                        strokeWeight: 3,
                        fillColor: zone.color,
                        fillOpacity: 0.35
                    });

                    currentZone.setMap(map);
                }
            });
        }
    }

    zoomDrawingMapToRestaurant(map) {

        // If there are other delivery zones for the restaurant fit the draw map to them
        if (this.props.inactiveDeliveryZones.length) {

            let formattedCords = [];
            let bounds = new window.google.maps.LatLngBounds();

            this.props.inactiveDeliveryZones.map((zone) => {

                if (zone.verticesCoordinates) {
                    zone.verticesCoordinates.map((cord) => {
                        let formattedCord = { lat: cord.latitude, lng: cord.longitude };
                        formattedCords.push(formattedCord);
                    });

                    let currentZone = new window.google.maps.Polygon({
                        paths: formattedCords,
                        strokeColor: zone.color,
                        strokeOpacity: 0.6,
                        strokeWeight: 3,
                        fillColor: zone.color,
                        fillOpacity: 0.35
                    });

                    currentZone.setMap(map);

                    // Add current Zone cords to map bounds so the map zoom to bounds
                    for (let i = 0, l = formattedCords.length; i < l; i++) {
                        bounds.extend(formattedCords[i]);
                    }

                    map.fitBounds(bounds);
                }

            });

        } else { // Fit the map to the restaurant city

            if (this.props.restaurant.address) {
                let latitude = this.props.restaurant.address.latitude;
                let longitude = this.props.restaurant.address.longitude;

                let formattedCords = [];
                let bounds = new window.google.maps.LatLngBounds();

                let formattedCord = { lat: latitude, lng: longitude };
                formattedCords.push(formattedCord);

                // Add current Zone cords to map bounds so the map zoom to bounds
                for (let i = 0, l = formattedCords.length; i < l; i++) {
                    bounds.extend(formattedCords[i]);
                }

                map.fitBounds(bounds);
            }

        }

        // Control the zoom of the map
        let listener = window.google.maps.event.addListener(map, "idle", function () {
            if (map.getZoom() > 16) map.setZoom(14);
            if (map.getZoom() <= 7) map.setZoom(14);
            window.google.maps.event.removeListener(listener);
        });

    }

    initDrawingMode(map) {
        // Add drawing manager to map
        let drawingManager = new window.google.maps.drawing.DrawingManager({
            drawingMode: window.google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
                position: window.google.maps.ControlPosition.TOP_CENTER,
                drawingModes: ['polygon']
            },
            polygonOptions: {
                fillColor: this.state.areaColor ? this.state.areaColor : 'GRAY',
                fillOpacity: 0.6,
                strokeColor: this.state.areaColor ? this.state.areaColor : 'GRAY',
                strokeWeight: 3,
                strokeOpacity: 0.35,
                clickable: true,
                editable: true,
                zIndex: 1
            }
        });

        drawingManager.setOptions({ drawingControl: true });

        this.setState({ ...this.state, drawingManager: drawingManager });

        drawingManager.setMap(map);

        // When we draw polygon this happens
        window.google.maps.event.addListener(drawingManager, 'polygoncomplete', (polygon) => {

            this.setState({
                ...this.state,
                mapDrawed: true
            });

            drawingManager.setDrawingMode(null);

            // Get the polygon cords so we can save them
            let updatedDeliveryZone = this.udpatePolygonCoordinates(polygon, drawingManager);

            // Save the polygon in the state so we can delete it if we want
            this.setState({ ...this.state, deliveryZone: updatedDeliveryZone, completedPolygon: polygon }, () => {
                const { completedPolygon } = this.state;

                // Loop through all paths in the polygon and add listeners
                // to them. If we just used `getPath()` then we wouldn't
                // detect all changes to shapes like donuts.
                completedPolygon.getPaths().forEach((path, index) => this.handlePolygonUpdate(path, completedPolygon, drawingManager));

            });
        });

    }

    handlePolygonUpdate(path, completedPolygon, drawingManager) {
        // New point
        window.google.maps.event.addListener(path, 'insert_at', (index) => {
            let updatedDeliveryZone = this.udpatePolygonCoordinates(completedPolygon, drawingManager);

            this.setState({ ...this.state, deliveryZone: updatedDeliveryZone, completedPolygon: completedPolygon });
        });

        // Point was removed
        window.google.maps.event.addListener(path, 'remove_at', (index) => {
            let updatedDeliveryZone = this.udpatePolygonCoordinates(completedPolygon, drawingManager);

            this.setState({ ...this.state, deliveryZone: updatedDeliveryZone, completedPolygon: completedPolygon });
        });

        // Point was moved
        window.google.maps.event.addListener(path, 'set_at', (index) => {
            let updatedDeliveryZone = this.udpatePolygonCoordinates(completedPolygon, drawingManager);

            this.setState({ ...this.state, deliveryZone: updatedDeliveryZone, completedPolygon: completedPolygon });
        });

    }

    udpatePolygonCoordinates(polygon, drawingManager) {
        let cordsArrayAsStrings = [];

        polygon.getPath().forEach(function (latLng) { cordsArrayAsStrings.push(latLng.toString()); });

        let polygonCoordinates = [];
        cordsArrayAsStrings.map((cord) => {

            let latLng = cord.split(',');

            let lat = latLng[0].substring(1);
            let lng = latLng[1];
            lng = lng.slice(0, -1);

            let formattedCord = {
                latitude: Number(lat),
                longitude: Number(lng)
            };

            polygonCoordinates.push(formattedCord);

        });

        let target = {
            target: {
                id: this.props.deliveryZone.id,
                name: 'verticesCoordinates',
                value: polygonCoordinates // pass the cords from polygon
            }
        };

        this.state.target = target;
        this.props.changeDeliveryZoneState(target);

        // Hide the drawing options after polygon is complete
        drawingManager.setOptions({ drawingControl: false });

        let updatedDeliveryZone = { ...this.state.deliveryZone };
        updatedDeliveryZone.verticesCoordinates = polygonCoordinates;

        return updatedDeliveryZone;
    }

    renderMap() {
        const { mapContainer } = this.props.styles;
        let mapId = 'drawingMap' + this.props.deliveryZone.id;
        let targetId = this.props.deliveryZone.id;
        let options = {
            zoom: 12,
            center: {
                lat: this.props.restaurant.address.latitude,
                lng: this.props.restaurant.address.longitude
            },
        }
        // We have DeliveryZone so render the
        if (this.state.deliveryZone && this.state.collapsibleContainerOpened) {

            return (
                <div style={mapContainer}>
                    <Map
                        id={mapId}
                        targetId={targetId}
                        options={options}
                        onMapLoad={map => {
                            this.renderShowMap(map);
                        }}
                        height={356}
                    />
                    {this.state.completedPolygon !== null ? this.renderDeleteAreaButton() : ''}
                </div>
            );

        } else if (!this.props.deliveryZone.id && this.props.restaurant) {
            let mapId = 'drawingMap' + Number(new Date());
            let targetId = Number(new Date());

            return (
                <div style={mapContainer}>
                    <Map
                        id={mapId}
                        targetId={targetId}
                        options={options}
                        onMapLoad={map => {
                            this.centerMapOnRestaurantCity(map);
                        }}
                        height={356}
                    />
                    {this.state.completedPolygon !== null ? this.renderDeleteAreaButton() : ''}
                </div>
            );
        }
    }

    renderCircleRuleMap() {
        const { mapContainer } = this.props.styles;

        let options = {
            zoom: 12,
            center: {
                lat: this.props.restaurant.address.latitude,
                lng: this.props.restaurant.address.longitude
            },
        }

        if (this.state.deliveryZone && this.state.collapsibleContainerOpened) {
            let mapId = 'drawingMap' + this.props.deliveryZone.id;
            let targetId = this.props.deliveryZone.id;
            return (
                <div style={mapContainer}>
                    <Map
                        id={mapId}
                        targetId={targetId}
                        options={options}
                        onMapLoad={map => {
                            this.setState({ ...this.state, zoneMap: map, isUpdateZone: true }, () => this.renderCircleZone(map));
                        }}
                        height={356}
                    />
                </div>
            );
        } else if (!this.props.deliveryZone.id && this.props.restaurant) {
            let mapId = 'drawingMap' + Number(new Date());
            let targetId = Number(new Date());
            return (
                <div style={mapContainer}>
                    <Map
                        id={mapId}
                        targetId={targetId}
                        options={options}
                        onMapLoad={map => {
                            this.setState({ ...this.state, zoneMap: map }, () => this.previewCircleZone(map));
                        }}
                        height={356}
                    />
                </div>
            );
        }
    }

    previewCircleZone(map) {
        const { measureUnit, startRange, endRange } = this.props.deliveryZone.deliveryZoneCircleRange;

        if (map && measureUnit && startRange && endRange) {
            let bounds = new window.google.maps.LatLngBounds();
            let circleZone = new window.google.maps.Polygon({
                paths: [this.props.drawCircle(new window.google.maps.LatLng(this.props.restaurant.address.latitude, this.props.restaurant.address.longitude), endRange, 1, this.props.deliveryZone.deliveryZoneCircleRange.measureUnit, bounds),
                this.props.drawCircle(new window.google.maps.LatLng(this.props.restaurant.address.latitude, this.props.restaurant.address.longitude), startRange, -1, this.props.deliveryZone.deliveryZoneCircleRange.measureUnit, bounds)],
                strokeColor: this.props.deliveryZone.color,
                strokeOpacity: 0.6,
                strokeWeight: 3,
                fillColor: this.props.deliveryZone.color,
                fillOpacity: 0.35
            });
            this.setState({ ...this.state, currentPolygonPreview: circleZone })
            circleZone.setMap(map);
            map.fitBounds(bounds);

        } else if (!map && this.state.currentPolygonPreview) {
            this.state.currentPolygonPreview.setMap(map);
            this.setState({ ...this.state, currentPolygonPreview: null })
        }
    }

    renderCircleZone(map) {

        if (map) {
            let bounds = new window.google.maps.LatLngBounds();
            if (this.props.deliveryZone.deliveryZoneCircleRange) {
                let start = this.props.deliveryZone.deliveryZoneCircleRange.startRange;
                let end = this.props.deliveryZone.deliveryZoneCircleRange.endRange;

                let circleZone = new window.google.maps.Polygon({
                    paths: [this.props.drawCircle(new window.google.maps.LatLng(this.props.restaurant.address.latitude, this.props.restaurant.address.longitude), end, 1, this.props.deliveryZone.deliveryZoneCircleRange.measureUnit, bounds),
                    this.props.drawCircle(new window.google.maps.LatLng(this.props.restaurant.address.latitude, this.props.restaurant.address.longitude), start, -1, this.props.deliveryZone.deliveryZoneCircleRange.measureUnit, bounds)],
                    strokeColor: this.props.deliveryZone.color,
                    strokeOpacity: 0.6,
                    strokeWeight: 3,
                    fillColor: this.props.deliveryZone.color,
                    fillOpacity: 0.35
                });
                this.setState({ ...this.state, currentPolygonPreview: circleZone })
                circleZone.setMap(map);
                map.fitBounds(bounds);
            }
        } else {
            if (this.state.currentPolygonPreview) {
                this.state.currentPolygonPreview.setMap(map);
                this.setState({ ...this.state, currentPolygonPreview: null });
            }
        }
    }

    handleColorSelect({ target }) {
        // Handle color select in drawing mode
        if (this.state.drawingManager) {

            // Drawing color
            this.state.drawingManager.setOptions({
                polygonOptions: {
                    fillColor: target.value,
                    fillOpacity: 0.6,
                    strokeColor: target.value,
                    strokeWeight: 3,
                    strokeOpacity: 0.35,
                    clickable: false,
                    editable: true,
                    zIndex: 1
                }
            });

            // Color of the drawed zone
            if (this.state.completedPolygon && this.state.drawingManager) {
                this.state.completedPolygon.setOptions({
                    strokeColor: target.value,
                    fillColor: target.value,
                });
            }

        }

        // Handle color select in show mode
        if (this.state.deliveryZone) {
            if (this.state.completedPolygon) {
                this.state.completedPolygon.setOptions({
                    strokeColor: target.value,
                    fillColor: target.value,
                });
            }
        }

        this.setState({
            ...this.state,
            areaColor: target.value
        });

    }

    collapseShowed() {
        this.setState({
            ...this.state,
            collapsibleContainerOpened: true
        });
    }

    handleInvalidSubmit(event, errors, values) {
        if (errors) {
            this.props.dispatchErrorMessage(i18n.t('actions:deliveryZonesActions.fillAllRequiredFieldsFailure'));
        }
    }

    toggleItemConfirmationScreen() {
        this.setState({ ...this.state, zoneConfirmationScreenOpened: !this.state.zoneConfirmationScreenOpened });
    }

    hideNewDeliveryZone() {
        const { spaceBetween, spaceBetweenBtns } = this.props.styles;
        const { hideNewDeliveryZone } = this.props;

        return (
            <Button onClick={() => {
                hideNewDeliveryZone();
            }}
                id="deleteDeliveryZoneItem"
                color="primary"
                outline
                style={spaceBetweenBtns}>
                <MaterialIcon icon="delete" color="#0288D1" size={18} />
                <span style={spaceBetween}>{i18n.t('common:buttons.delete')}</span>
            </Button>
        );
    }

    render() {
        const { cardBody, activeCheckbox, zeroPadding, alignRight, areaColorSelect, avSelect, activeLabel } = this.props.styles;
        const { id, active } = this.props.deliveryZone;
        const { changeDeliveryZoneState, update } = this.props;
        const isHidden = this.props.zoneType === 'ZIP_CODE_BASED' ? true : false;
        const collapsedNewZone = (this.props.newZone === true) ? 'collapse show' : 'collapse';
        const textData = {
            header: i18n.t('screens:deliveryZoneItem.msgHeader'),
            firstRow: i18n.t('screens:deliveryZoneItem.msgFirstRow'),
            secondRow: i18n.t('screens:deliveryZoneItem.msgSecondRow')
        };
        const isUserIsAdminOrMasterAdmin = isUserAllowedToAddBrands(this.props.currentlyLoggedInUser)
        return (
            <div>
                <AvForm onValidSubmit={() => {

                    let hasEmptyValue = false;
                    for (const key in this.child.state.fields) {
                        if (!this.child.state.fields[key]) {
                            hasEmptyValue = true;
                        }
                    }

                    if (hasEmptyValue) {
                        this.props.dispatchErrorMessage(i18n.t('actions:deliveryActions.deliveryProviderSettingsEmpty'));
                        return;
                    }

                    update(this.state.mapDrawed, this.child.saveDeliveryPartnerSettings);
                }} onInvalidSubmit={this.handleInvalidSubmit.bind(this)}>
                    <Card className="deliveryZoneCards">
                        {this.renderCardHeader()}
                        <UncontrolledCollapse onEntered={this.collapseShowed.bind(this)} toggler={`#toggler${id}`} className={collapsedNewZone}>
                            <CardBody style={cardBody}>
                                <Row>
                                    {this.renderCardBodyLeftColumn()}
                                    <Col sm={7}>
                                        {this.props.zoneType === 'MAP_BASED' && this.renderMap()}
                                        {this.props.zoneType === 'ZIP_CODE_BASED' && this.renderZipCodes()}
                                        {this.props.zoneType === 'CIRCLE_BASED' && this.renderCircleRuleMap()}
                                    </Col>
                                    <Col sm={12}>
                                         {this.props.zoneType === 'CIRCLE_BASED' ? this.renderCircleTypeButtons() : null}
                                    </Col>
                                    <Col sm={2}>
                                        <AvGroup>
                                            <Label style={activeLabel}>{i18n.t('common:buttons.active')}</Label>
                                            <AvInput id={id}
                                                style={activeCheckbox} type="checkbox" name="active"
                                                value={!!active} onChange={changeDeliveryZoneState}
                                            />
                                        </AvGroup>
                                    </Col>
                                    <Col sm={10}>
                                        <AvGroup row >
                                            <Label sm={2} style={{...areaColorSelect, textAlign: 'right', marginLeft: 0, marginRight:'15px'}} hidden={isHidden}>{i18n.t(`screens:deliveryZoneItem.areaColors`)}</Label>
                                            <Col sm={5} style={zeroPadding} hidden={isHidden}>
                                                <AvField style={avSelect}
                                                    id={id + ''} type="select" name="color"
                                                    value={this.state.areaColor ? this.state.areaColor : 'GRAY'}
                                                    onChange={(target) => {
                                                        this.handleColorSelect(target);
                                                        changeDeliveryZoneState(target);
                                                    }}
                                                >
                                                    {this.renderColorOptions()}
                                                </AvField>
                                            </Col>
                                        </AvGroup>
                                    </Col>
                                    < DeliveryProviderByZoneScreen
                                        onRef={ref => (this.child = ref)}
                                        deliveryPartnerSettings={this.props.deliveryZone.deliveryPartnerSettings}
                                        deliveryZoneId={this.props.deliveryZone.id}
                                        deliveryProvider={this.props.deliveryProvider}
                                        isUserIsAdminOrMasterAdmin={isUserIsAdminOrMasterAdmin}
                                    />
                                </Row>
                                <Col style={alignRight}>
                                    {this.renderSaveButton()}
                                    {(id) ? this.renderDeleteButton(id) : this.hideNewDeliveryZone()}
                                </Col>
                                <div className="scroll" ref={(ref) => this.state.scrollToElement = ref}>
                                </div>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                </AvForm>
                <DeliveryZoneConfirmationScreen
                    isOpen={this.state.zoneConfirmationScreenOpened}
                    onToggle={this.toggleItemConfirmationScreen.bind(this)}
                    deliveryZone={this.state.deliveryZone}
                    onSave={() => { this.props.deleteZoneAfterConfirmationScreen(id) }}
                    message={textData}
                    hasDeleteBtn={true}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentlyLoggedInUser: state.user
    }
}

export default connect(mapStateToProps, { dispatchErrorMessage })(DeliveryZoneItem);


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/DeliveryZoneItem.js